/* eslint-disable i18next/no-literal-string */
import React, { useState } from 'react';

import Key from '@ast/magma/components/icon/icons/Key';
import Trash from '@ast/magma/components/icon/icons/Trash';

import { Button } from '@ast/magma/components/button';

import { useBreakpoint } from '@ast/magma';

import { Passkey } from '@app/queryTyping';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import styles from './PasskeyItem.pcss';
import { PasskeyRevokeModal } from './PasskeyRevokeModal';

interface PasskeyItemProps {
  isLoadingRevokePasskey: boolean;
  passkeyRevokeError: string;
  passkey: Passkey;
  onDeletePasskey: () => Promise<unknown>;
}

export const PasskeyItem = ({
  isLoadingRevokePasskey,
  passkeyRevokeError,
  passkey,
  onDeletePasskey,
}: PasskeyItemProps) => {
  const { t } = useUserSettingsTranslation();

  const [revokeModalOpen, setRevokeModalOpen] = useState(false);

  const isMobile = useBreakpoint().device === 'mobile';

  const renderPasskeyLastUsed = () => (
    <>
      {t('profile-and-security.passkey-item.passkey-last-used-time|Passkey last used time',
        'Last used on')}
      {' '}
      {passkey.lastTimeUsed}
    </>
  );

  return (
    <>
      <div data-stable-name="PasskeyRow" className={styles.passkeyItemRow}>
        <div data-stable-name="PasskeyName" className={styles.passkeyItemName}>
          <div>
            <Key />
          </div>
          <div className={styles.passkeyDetails}>
            <span>
              {t('profile-and-security.passkey-item.passkey-title|Passkey item title',
                'Passkey')}
            </span>
            <span className={styles.passkeyItemSecondaryText}>
              {t('profile-and-security.passkey-item.passkey-added-time|Passkey added time',
                'Added on')}
              {' '}
              {passkey.created}
            </span>
            {isMobile && (
            <span className={styles.passkeyItemSecondaryText}>
              {passkey.lastTimeUsed
                ? (
                  <>
                    {renderPasskeyLastUsed()}
                  </>
                ) : ''}
            </span>
            )}
          </div>
        </div>
        {!isMobile && (
        <div data-stable-name="PasskeyLastUsed">
          <span className={styles.passkeyItemSecondaryText}>
            {passkey.lastTimeUsed
              ? (
                <>
                  {renderPasskeyLastUsed()}
                </>
              ) : ''}
          </span>
        </div>
        )}
        <div>
          <Button
            data-stable-name="DeleteButton"
            aria-label={t('profile-and-security.passkey.item.delete-button-aria-label|Delete button aria label',
              'Delete passkey')}
            className={styles.button}
            onClick={() => setRevokeModalOpen(true)}
            icon={<Trash />}
            look="icon"
          />
        </div>
      </div>
      {revokeModalOpen && (
      <PasskeyRevokeModal
        isLoadingRevokePasskey={isLoadingRevokePasskey}
        passkeyRevokeError={passkeyRevokeError}
        setRevokeModalOpen={setRevokeModalOpen}
        onDeletePasskey={onDeletePasskey}
      />
      )}
    </>
  );
};
